<template>
  <UPopover :content="{
    align: 'center',
    side: contentSide,
    sideOffset: 8
  }">
    <UButton label="Cookies" color="primary" :variant=variant :icon="icon" />

    <template #content>
      <div class="max-w-sm p-4 text-sm leading-relaxed">
        Această aplicație utilizează exclusiv module cookie strict necesare pentru funcționarea tehnică și
        autentificarea în contul dumneavoastră, în conformitate cu Regulamentul GDPR și Directiva E-Privacy. Acestea
        sunt scutite de obligația obținerii consimțământului prealabil, fiind indispensabile furnizării serviciului
        solicitat de utilizator. Nu utilizăm tehnologii de tracking sau profilare a vizitatorilor. Prin continuarea
        utilizării aplicației, vă exprimați acordul cu stocarea acestor fișiere esențiale pentru securitatea și
        stabilitatea sesiunii de lucru.
      </div>
    </template>
  </UPopover>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  contentSide?: 'left' | 'right' | 'top' | 'bottom'
  variant?: 'soft' | 'solid' | 'link'
  icon?: string
}>(), {
  contentSide: 'bottom',
  variant: 'soft'
})
</script>